import script from "./IconShieldKey.vue?vue&type=script&setup=true&lang=js"
export * from "./IconShieldKey.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./IconShieldKey.vue?vue&type=custom&index=0&blockType=el-icon"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__